import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  boxShadow,
  BoxShadowProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseFooterProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    SpaceProps,
    TypographyProps,
    BoxShadowProps {
  overflowScrolling?: string;
  WebkitOverflowScrolling?: string;
}

type NonCollidingFooterProps = WithoutCollidingProps<BaseFooterProps, 'footer'>;
type NonCollidingFooterKeys = keyof NonCollidingFooterProps;

export const Footer = styled('footer', {
  shouldForwardProp: (prop): prop is NonCollidingFooterKeys =>
    shouldForwardProp(prop as NonCollidingFooterKeys),
})<BaseFooterProps>(
  defineWithTheme('footers'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    typography,
    boxShadow
  )
);

export type FooterProps = React.ComponentPropsWithoutRef<typeof Footer>;
